import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';

@Component({
    selector: 'material-radio-group',
    templateUrl: './radio-group.component.html',
    styleUrls: ['./radio-group.component.scss'],
    standalone: false,
})
export class MaterialRadioGroupComponent {
    private static nextId = 0;
    public uniqueGroupName = `radioGroup_${MaterialRadioGroupComponent.nextId++}`;

    @Input() radioOptions: any[] = [];
    @Input() selectedValue: any;
    @Output() selectionChanged = new EventEmitter<any>();

    @Input() radioGroupClassList: string[] = [];
    @Input() radioButtonClassList: string[] = [];
    @Input() ariaLabelledBy: string | null = null;
    @Input() ariaLabel: string | null = 'Select an option';
    @Input() disabled = false;
    @Input() emitEvent = false;
    @Input() name: string | null = null;

    computedGroupClasses: string[] = [];
    computedButtonClasses: string[] = [];

    ngOnChanges(_changes: SimpleChanges): void {
        this.updateClassLists();
    }

    updateClassLists(): void {
        this.computedGroupClasses = ['default-radio-group', ...this.radioGroupClassList];
        this.computedButtonClasses = ['default-radio-button', ...this.radioButtonClassList];
    }

    onSelectionChange(value: any): void {
        this.selectionChanged.emit(value);
    }
}
